module.exports = __webpack_public_path__ + "static/media/A3.28303a6c.jpg";